import axios from 'axios';
import { CustomerProgram, Visit } from './models';


export default {
	/**
	 * Get all customer programs for current user.
	 * @returns {Promise<CustomerProgram[]|Boolean>} Array of customer programs, or `false` if request failed.
	 */
	async GetCustomerPrograms(params) {
		const result = await axios.post('/api/ajax/RewardApi/GetCustomerPrograms', params);
		switch (Object(result.data).ResponseCode) {
			case 200:
			case 204:
				return result.data.CustomerPrograms.map(customerProgram => new CustomerProgram(customerProgram));

			default:
				return false;
		}
	},

	/**
	 * Get all bonuspoint transactions for provided customerId.
	 * @param {String} customerId - The customer's ID.
	 * @returns {Promise<Visit[]|Boolean>} Array of appointments/visits referenced as bonuspoint transactions.
	 */
	async GetBonuspointTransactions(customerId = '') {
		const result = await axios.post('/api/ajax/RewardApi/GetBonusPointTransactionHistory', { CustomerId: customerId });
		switch (Object(result.data).ResponseCode) {
			case 200:
			case 204:
				return result.data.Appointments.map(appointment => new Visit({ ...appointment, appointmentId: null, visitId: appointment.AppointmentId }));

			default:
				return false;
		}
	},

	/**
	 * Toggle customer's subscription for provided customer program.
	 * - **Note:** If no existing customer profiles in the chain, we create one from the logged in onlinesluttkunde!
	 * @param {CustomerProgram} customerProgram - The customer program to toggle subscription for.
	 */
	async ToggleCustomerProgramSubscription(customerProgram = new CustomerProgram()) {
		
		const result = await axios.post('/api/ajax/RewardApi/AddOrRemoveCustomerProgramForCustomer', {
			CustomerId: customerProgram.customers[0].customerId,
			CustomerCategoryId: customerProgram.defaultCustomerCategoryId,
			RegisterCustomerInCustomerProgram: !customerProgram.customers[0].isInCustomerProgram
		});
		switch (Object(result.data).ResponseCode) {
			case 202:
				return true;

			default:
				return false;
		}
	},
	/**
	 * Check if the chain has an active customer program
	 * @returns {<Boolean>} True or False, if the chain has an active customer program
	 */
	async HasActiveCustomerProgram(params) {
		const result = await axios.post('/api/ajax/RewardApi/GetActiveCustomerProgramByChainId', {'chainId': params});
		switch (Object(result.data).ResponseCode) {
			case 200:
			case 204:
				if (result.data.CustomerPrograms.length) return true
				else return false
			default:
				return false;
		}
	},
};
